module.exports = __webpack_public_path__ + "static/media/vine.38cccc99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vine.svg
// module id = 207
// module chunks = 0